<template>
    <div class="profile-skills-read-only" :data-testid="`${props.dataTestid}-list`">
        <ProfileSkillSetItem
            v-for="(skill, index) in props.skills"
            :key="`profile-main-top-skill-${index}`"
            :data-testid="`${props.dataTestid}-${index}`"
            :href="getSeoUrl(skill)"
            :is-enabled-tooltip="props.isEnabledTooltip"
            :size="props.size"
            :variant="skill.status === 'profile-only' ? 'inactive' : 'secondary'"
            class="profile-skills-read-only__item"
            @click="emit('clicked')"
        >
            {{ getLabel(skill) }}
        </ProfileSkillSetItem>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {toRef} from '#imports';
    import type {TJoyTagSizes} from '@maltjoy/core-vue';
    import type {SkillMatchStatus} from '~/store/advancedSearch.store';
    import ProfileSkillSetItem from '@/components/_common/skill-set/ProfileSkillSetItem.vue';

    export type Skill = {label: string; translatedLabel?: string; seoUrl?: string; id: string; status?: SkillMatchStatus};

    interface Props {
        dataTestid: string;
        isVisibleSeoLink?: boolean;
        isVisibleTranslatedLabel?: boolean;
        isEnabledTooltip?: boolean;
        skills: readonly Skill[];
        size?: TJoyTagSizes;
        gap?: 'small' | 'medium';
    }

    const props = withDefaults(defineProps<Props>(), {isVisibleSeoLink: false, isVisibleTranslatedLabel: false, isEnabledTooltip: true});
    const isVisibleTranslatedLabel = toRef(props, 'isVisibleTranslatedLabel');
    const gap = computed(() => (props.gap === 'small' ? 'var(--joy-core-spacing-2)' : 'var(--joy-core-spacing-4)'));

    const emit = defineEmits<{
        clicked: [];
    }>();

    function getSeoUrl(skill: Skill): string | undefined {
        return (!!props.isVisibleSeoLink && skill.seoUrl) || undefined;
    }

    function getLabel(skill: Skill) {
        return isVisibleTranslatedLabel.value && skill.translatedLabel ? skill.translatedLabel : skill.label;
    }
</script>

<style lang="scss">
    .profile-skills-read-only {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        gap: v-bind(gap);

        &__item {
            cursor: pointer;
        }
    }
</style>
